import { Reveal } from './helpers';

export const Philosophy = () => (
    <section id="philosophy" className="py-32 scroll-mt-16 border-t border-border/40 bg-background relative overflow-hidden">
        <div className="absolute left-1/2 -translate-x-[min(50vw,640px)] top-16 bottom-16 w-px bg-border/40 hidden md:block" />

        <div className="max-w-5xl mx-auto px-6">
            <Reveal className="max-w-3xl">
                <p className="text-[11px] uppercase tracking-[0.2em] text-primary font-semibold mb-8">Our philosophy</p>

                <blockquote className="relative">
                    <span aria-hidden="true" className="absolute -top-8 -left-2 sm:-left-10 text-[120px] sm:text-[160px] leading-none text-primary/15 font-serif select-none">
                        &ldquo;
                    </span>

                    <p className="text-2xl sm:text-3xl lg:text-[36px] font-medium tracking-[-0.02em] leading-[1.25] text-foreground">
                        If you approach this work as <span className="text-muted-foreground/80">documentation</span>, you will produce{' '}
                        <span className="text-muted-foreground/80">documentation</span>.
                        <span className="block mt-6">
                            If you approach this work as <span className="text-primary">cognitive reconstruction</span>, you will produce something that changes how an organization survives
                            transitions.
                        </span>
                    </p>
                </blockquote>

                <div className="mt-10 flex items-center gap-3 text-xs text-muted-foreground">
                    <span className="block w-10 h-px bg-primary/60" />
                    <span className="uppercase tracking-[0.18em] font-semibold">The conviction Handoff is built on</span>
                </div>

                <p className="mt-10 text-base sm:text-lg text-muted-foreground max-w-2xl leading-relaxed">
                    Every product decision we've made — the consultant-led sessions, the Decision Unit format, the AI coach trained on the playbook, the deliverables that go to the person leaving
                    — flows from this single line. Documentation is what you write when you don't know how to capture thinking. We learned how.
                </p>
            </Reveal>
        </div>
    </section>
);
